// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/MinusCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleTwoToneSvg
  }));
};

MinusCircleTwoTone.displayName = 'MinusCircleTwoTone';
export default /*#__PURE__*/React.forwardRef(MinusCircleTwoTone);